export const COLORS = {
  while: '#fff',
  black: '#000',
  main: '#5e35b1',
  bgButton: '#203461',
  red: '#E30736',
  text: '#4E4E4E',
  textInput: '#222222',
  gray: '#F4F4F4',
  //origin
  origin: '#FFF2EE',
  originText: '#F57322'
}
